import { FunctionComponent } from "react";
import FRAME1 from "./FRAME1";
import styles from "./FRAME.module.css";

const FRAME: FunctionComponent = () => {
  return (
    <section className={styles.fRAME}>
      <h1 className={styles.theIndustryAdvisors}>
        The industry advisors behind Cryptic Labs
      </h1>
      <div className={styles.fRAME1}>
        <FRAME1
          image59="/image-49@2x.png"
          drEricSMaskin="Jan Liphardt"
          ericMaskinIsTheAdamsUnive="Jan Liphardt is an Associate Professor of Bioengineering at Stanford University. He has a physics background."
          propHeight="unset"
        />
        <FRAME1
          image59="/image-48@2x.png"
          drEricSMaskin="Dan Kolkowitz"
          ericMaskinIsTheAdamsUnive="Mr. Kolkowitz brings more than 25 years of experience developing security and network technologies for distributed systems."
          propHeight="unset"
        />
        <FRAME1
          image59="/image-51@2x.png"
          drEricSMaskin="Evelyn Hytopoulos"
          ericMaskinIsTheAdamsUnive="Evelyn Hytopoulos is a senior blockchain economist and the former Chief Economist."
          propHeight="unset"
        />
        <FRAME1
          image59="/image-50@2x.png"
          drEricSMaskin="Prof. Jiri Materna"
          ericMaskinIsTheAdamsUnive="Dr. Jiri Materna is a machine learning expert with basic and applied research experience. "
          propHeight="unset"
        />
      </div>
    </section>
  );
};

export default FRAME;
